module.exports = __webpack_public_path__ + "img/jsfni5.e8cc20b5.png";